import { apiFetch } from '@/lib/api/http';

/** サクセス面談議事録・フォローアップ（指示書 §5.1・§6・§12 M10 / DECISIONS D-002）. */
export type SuccessVisibilityScope = 'success_and_office' | 'assigned_success_only_and_office';

export const VISIBILITY_SCOPE_LABELS: Record<SuccessVisibilityScope, string> = {
  success_and_office: 'サクセス全員+事務局に公開',
  assigned_success_only_and_office: '自分（担当サクセス）+事務局のみ',
};

export interface SuccessRecord {
  id: string;
  member_id: string;
  member_name: string | null;
  success_user_id: string;
  occurred_at: string;
  minutes_body: string;
  external_url: string | null;
  visibility_scope: SuccessVisibilityScope;
}

export function createSuccessRecord(payload: {
  member_id: string;
  occurred_at: string;
  minutes_body: string;
  external_url?: string | null;
  visibility_scope: SuccessVisibilityScope;
}): Promise<SuccessRecord> {
  return apiFetch<SuccessRecord>('/success-records', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
}

export function fetchSuccessRecords(memberId?: string): Promise<SuccessRecord[]> {
  const query = memberId ? `?member_id=${encodeURIComponent(memberId)}` : '';
  return apiFetch<SuccessRecord[]>(`/success-records${query}`);
}

export function updateSuccessRecord(
  recordId: string,
  payload: {
    minutes_body: string;
    external_url?: string | null;
    visibility_scope: SuccessVisibilityScope;
  },
): Promise<SuccessRecord> {
  return apiFetch<SuccessRecord>(`/success-records/${recordId}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
}

export type FollowUpStatus = 'open' | 'done' | 'cancelled';

export const FOLLOW_UP_STATUS_LABELS: Record<FollowUpStatus, string> = {
  open: '未対応',
  done: '完了',
  cancelled: '取消',
};

export interface FollowUp {
  id: string;
  record_id: string;
  title: string;
  due_at: string | null;
  status: FollowUpStatus;
  done_at: string | null;
}

export function createFollowUp(payload: {
  record_id: string;
  title: string;
  due_at?: string | null;
}): Promise<FollowUp> {
  return apiFetch<FollowUp>('/follow-ups', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
}

export function fetchFollowUps(status?: FollowUpStatus): Promise<FollowUp[]> {
  const query = status ? `?status=${status}` : '';
  return apiFetch<FollowUp[]>(`/follow-ups${query}`);
}

export function setFollowUpStatus(followUpId: string, status: FollowUpStatus): Promise<FollowUp> {
  return apiFetch<FollowUp>(`/follow-ups/${followUpId}/status`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ status }),
  });
}
